module.exports = __webpack_public_path__ + "img/icon-youtube-gray.4ff940ab.svg";